import i18n from '@/plugins/i18n';
import { getForcastChartConfig } from '@/components/Common/graphV3ConfigGenerator';

export const clusterMetricsData = () => [
  {
    metricName: 'K8S_NAMESPACE',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterNamespceTotal'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'K8S_NODE',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterNodeTotal'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'K8S_DEPLOYMENT',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterDeploymentTotal'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'K8S_STATEFULSET',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterStatefulsets'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'K8S_DAEMON_SET',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterDaemonsets'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'K8S_POD',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterPodTotal'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'instance',
  },
  {
    metricName: 'k8s_cluster_v2_container_total',
    className: 'bg-dark-black k8m-cluster-info-cards',
    textTitle: i18n.global.t('k8.clusterContainerTotal'),
    textValColor: 'white',
    textValue: '0',
    valueType: 'value',
  },
];

export const clusterUsageForecastGraphs = [
  getForcastChartConfig({
    title: i18n.global.t('k8.cpuUsage'),
    width: '49%',
    metricName: 'k8s_cluster_v2_cpu_usage',
    axisLabelsY: i18n.global.t('k8.percentage'),
    entityType: 'Service',
    header: {
      titlePrefixIcon: '',
      displayOnlyUnit: false,
    },
  }),
  getForcastChartConfig({
    title: i18n.global.t('k8.memoryUsage'),
    width: '49%',
    metricName: 'k8s_cluster_v2_memory_usage',
    axisLabelsY: i18n.global.t('k8.percentage'),
    entityType: 'Service',
    header: {
      titlePrefixIcon: '',
      displayOnlyUnit: false,
    },
  }),
  getForcastChartConfig({
    title: i18n.global.t('k8.volUsage'),
    width: '49%',
    metricName: 'k8s_cluster_v2_fs_usage',
    axisLabelsY: i18n.global.t('k8.percentage'),
    entityType: 'Service',
    header: {
      titlePrefixIcon: '',
      displayOnlyUnit: false,
    },
  }),
];

export const clusterUsageAOGraphs = () => [
  {
    width: '49%',
    title: i18n.global.t('k8.cpuUsage'),
    isForecast: true,
    header: {
      title: i18n.global.t('k8.cpuUsage'),
      titleIcon: '',
      content: [],
      HideCenterMiscContent: true,
      subIconTitle: 'starFilled',
      displayOnlyUnit: false,
      displayCustomButton: false,
    },
    chartColor: ['#F59600', '#EA7699'],
    height: '12.5em',
    entityType: 'ServiceInstance',
    independentSelector: false,
    metricType: 'REGULAR_VALUE',
    metricName: 'k8s_cluster_v2_cpu_usage',
    queryMetricType: 'readMetricsValues',
    chartType: 'ApexChartLine',
    unit: '%',
    axisLabels: {
      x: 'Time',
      y: 'Percentage',
    },
    labels: {
      xAxis: 'Time',
      yAxis: 'CPM',
    },
    compareTrend: true,
  },
  {
    width: '49%',
    title: i18n.global.t('k8.memoryUsage'),
    isForecast: true,
    header: {
      title: i18n.global.t('k8.memoryUsage'),
      titleIcon: '',
      content: [],
      HideCenterMiscContent: true,
      subIconTitle: 'starFilled',
      displayOnlyUnit: false,
      displayCustomButton: false,
    },
    chartColor: ['#F59600'],
    height: '12.5em',
    entityType: 'ServiceInstance',
    independentSelector: false,
    metricType: 'REGULAR_VALUE',
    metricName: 'k8s_cluster_v2_memory_usage',
    queryMetricType: 'readMetricsValues',
    chartType: 'ApexChartLine',
    unit: '%',
    axisLabels: {
      x: 'Time',
      y: 'Percentage',
    },
    labels: {
      xAxis: 'Time',
      yAxis: 'CPM',
    },
    compareTrend: true,
  },
  {
    width: '49%',
    title: i18n.global.t('k8.volUsage'),
    isForecast: true,
    header: {
      title: i18n.global.t('k8.volUsage'),
      titleIcon: '',
      content: [],
      HideCenterMiscContent: true,
      subIconTitle: 'starFilled',
      displayOnlyUnit: false,
      displayCustomButton: false,
    },
    chartColor: ['#F59600', '#EA7699'],
    height: '12.5em',
    entityType: 'ServiceInstance',
    independentSelector: false,
    metricType: 'REGULAR_VALUE',
    metricName: 'k8s_cluster_v2_fs_usage',
    queryMetricType: 'readMetricsValues',
    chartType: 'ApexChartLine',
    unit: '%',
    axisLabels: {
      x: 'Time',
      y: 'Percentage',
    },
    labels: {
      xAxis: 'Time',
      yAxis: 'CPM',
    },
    compareTrend: true,
  },
  {
    width: '49%',
    title: i18n.global.t('k8.storageUsage'),
    header: {
      title: i18n.global.t('k8.storageUsage'),
      titleIcon: '',
      content: [],
      HideCenterMiscContent: true,
      displayOnlyUnit: false,
      displayCustomButton: false,
    },
    chartColor: ['#F59600'],
    height: '12.5em',
    entityType: 'ServiceInstance',
    independentSelector: false,
    metricType: 'REGULAR_VALUE',
    metricName: 'k8s_cluster_v2_ephemeral_storage_allocatable',
    queryMetricType: 'readMetricsValues',
    chartType: 'ApexChartLine',
    aggregation: '/',
    aggregationNum: '1048576',
    unit: 'CPM - calls per minute',
    axisLabels: {
      x: 'Time',
      y: 'MB',
    },
    labels: {
      xAxis: 'Time',
      yAxis: 'CPM',
    },
  },
];

export const FORECAST_QUERY_NAME = 'queryGetAIMetricValues';

export const LINE_QUERY_NAME = 'queryGetAOMetricValues';
